










































import {Component, Prop, Vue} from 'vue-property-decorator'
import {ResponsavelConfigWhatsapp} from '@/model/resource/ResponsavelConfigWhatsapp'
import {InputResponsavelConfigWhatsappSchema} from '@/schema/resource/ResponsavelConfigWhatsapp/InputResponsavelConfigWhatsappSchema'
import {StatusWhatsapp} from '@/model/resource/StatusWhatsapp'

@Component
export default class ModalApproveWhatsapp extends Vue {
  model = new ResponsavelConfigWhatsapp()
  schema = new InputResponsavelConfigWhatsappSchema()

  async openEvent(id?: number) {
    this.$emit('open')

    if (id) {
      await this.model.getResponsavelConfigWhatsapp(id)
      this.model.templateId = null
    } else {
      this.close()
    }
  }

  closeEvent() {
    this.$emit('close')
  }

  async confirmEvent() {
    this.model.idWhatsappStatusFk = StatusWhatsapp.APROVADO
    await this.model.persistResponsavelConfigWhatsapp()
    this.$emit('confirm', this.model.$id)
    this.close()
  }

  async cancelEvent() {
    this.$emit('cancel')
    this.close()
  }

  close() {
    this.$modal.close('approveWhatsapp')
  }
}
